
import {throwError as observableThrowError, Subject, Observable} from 'rxjs';

import {catchError, map, switchMap} from 'rxjs/operators';

import {Injectable, Injector} from '@angular/core';
import {Menu} from './model/menu.model';
import {MenuItem} from './model/menuitem.model';
import {ServiceReg} from '../../auth/auth.module';
import {NavbarMenu} from './model/navbar-menu.model';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import {ConfigService} from '../config.service';
import {ApiMessageService, MessageType} from '../api-message.service';

@Injectable()
export class MenuService {

  public navbarEvaluated = new Subject<NavbarMenu>();

  public navbarMenu: NavbarMenu = null;

  public constructor(private injector: Injector,
                     private configService: ConfigService,
                     private apiMessageService: ApiMessageService,
                     protected httpClient: HttpClient) {}

  public destroyNavbar() {
    this.navbarMenu = null;
    this.navbarEvaluated.next(this.navbarMenu);
  }

  /**
   * Costruisce gli oggetti del menu.
   */
  public buildNavbar() {

    const anagraficaItems = [];

    anagraficaItems.push(new MenuItem(ServiceReg.PERSONA, 'users', '/anagrafica/persona', 'Persone'));

    /**
     * Albero di menu Ruoli Assegnati 
     */
    const ruoliAssegnatiItems = [];

    ruoliAssegnatiItems.push(new MenuItem(ServiceReg.RUOLO_PERSONA, 'graduation-cap', '/anagrafica/ruolopersona', 'Definitivi'));
 
    ruoliAssegnatiItems.push(new MenuItem(ServiceReg.RUOLO_PERSONA_PROVV, 'graduation-cap', '/anagrafica/ruolopersona/provv', 'Gestione Provvisori'));
 
    anagraficaItems.push(new Menu('ruoliAssegnatiMenu', 'cube', ruoliAssegnatiItems));

    //anagraficaItems.push(new MenuItem(ServiceReg.RUOLO_PERSONA, 'graduation-cap', '/anagrafica/ruolopersona', 'Ruoli Assegnati'));

    
    /**
     * Albero di menu Entita Organizzativa 
     */
    const entitaorganizzativaItems = [];

    entitaorganizzativaItems.push(new MenuItem(ServiceReg.ENTITA_ORGANIZZATIVA, 'cube', '/anagrafica/entitaorganizzativa', 'Entita Organizzative'));

    entitaorganizzativaItems.push(new MenuItem(ServiceReg.FASCIA, 'credit-card', '/configurazione/fascia', 'Fasce'));

    entitaorganizzativaItems.push(new MenuItem(ServiceReg.FASCIA_ENTITA_ORGANIZZATIVA, 'link', '/anagrafica/fasciaentitaorganizzativa', 'Associa Fasce'));

    anagraficaItems.push(new Menu('entitaOrganizzative', 'cube', entitaorganizzativaItems));

        
    
    anagraficaItems.push(new MenuItem(ServiceReg.ENTITA_LOCALE, 'map-marker', '/anagrafica/entitalocale', 'Entita Locali'));

    anagraficaItems.push(new MenuItem(ServiceReg.PERSONA_ENTITA_ORGANIZZATIVA, 'users', '/anagrafica/personaentitaorganizzativa', 'Appartenenza'));

    anagraficaItems.push(new MenuItem(ServiceReg.GERARCHIA_TREE, 'sitemap', '/anagrafica/gerarchia-tree', 'Gerarchia'));

    anagraficaItems.push(new MenuItem(ServiceReg.GERARCHIA, 'code-fork', '/anagrafica/gerarchia', 'Rami Gerarchia'));

    const confItems = [];

    const allConfItem = new MenuItem(null, 'th-list', '/configurazione', 'Tutte le configurazioni');

    allConfItem.dependent = true;

    confItems.push(allConfItem);

    confItems.push(new MenuItem(ServiceReg.RUOLO, 'graduation-cap', '/configurazione/ruolo', 'Ruoli', [allConfItem]));

    confItems.push(new MenuItem(ServiceReg.CONTESTO, 'object-group', '/configurazione/contesto', 'Contesti', [allConfItem]));

    confItems.push(new MenuItem(ServiceReg.TIPO_ENTITA_ORGANIZZATIVA, 'cubes',
      '/configurazione/tipoentitaorganizzativa', 'Tipi Entita Organizzative', [allConfItem]));

    confItems.push(new MenuItem(ServiceReg.CATEGORIA_TIPI_EO, 'tag',
      '/configurazione/categoriatipieo', 'Categoria Tipi Entita Organizzative', [allConfItem]));

    confItems.push(new MenuItem(ServiceReg.TIPO_ENTITA_LOCALE, 'map-marker',
      '/configurazione/tipoentitalocale', 'Tipi Entita Locale', [allConfItem]));
    confItems.push(new MenuItem(ServiceReg.TIPO_GERARCHIA, 'sitemap', '/configurazione/tipogerarchia', 'Tipi Gerarchia', [allConfItem]));

    confItems.push(new MenuItem(ServiceReg.TIPO_GERARCHIA_STRUTTURA, 'sitemap',
      '/configurazione/tipogerarchiastruttura', 'Struttura Tipi Gerarchia', [allConfItem]));

    const usersItems = [];

    usersItems.push(new MenuItem(ServiceReg.UTENTE, 'users', '/configurazione/utente', 'Utenti'));

    usersItems.push(new MenuItem(ServiceReg.RUOLO_UTENTE, 'graduation-cap', '/configurazione/ruoloutente', 'Ruoli Utente'));

    usersItems.push(new MenuItem(ServiceReg.CRUSCOTTO, 'th-list', '/configurazione/cruscotto', 'Cruscotto'));

    const anagrafica = new Menu('anagrafica', 'table', anagraficaItems);

    const configurazione = new Menu('configurazione', 'cogs', confItems);

    const utenti = new Menu('utenti', 'users', usersItems);

    this.navbarMenu = new NavbarMenu([anagrafica, configurazione, utenti]);

  }

  /**
   * Valuta gli oggetti del menu.
   */
  public evaluateNavbar() {

    // build
    if (!this.navbarMenu) {
      this.buildNavbar();
    }

    this.getPermittedPaths(this.navbarMenu.getPaths(this.injector)).subscribe(permittedPaths => {
      this.navbarMenu.evaluate(permittedPaths);
      this.navbarEvaluated.next(this.navbarMenu);
    });
  }

  private getPermittedPaths(paths: string[]): Observable<string[]> {

    return this.configService.getApiBase().pipe(switchMap((apiBase) => {
      return this.httpClient.post<string[]>(apiBase + ConfigService.ACE + '/v1/pcheck', { 'paths': paths}).pipe(
        map((result) => {
          return result;
        }),catchError((httpErrorResponse: HttpErrorResponse) => {
          this.apiMessageService.sendMessage(MessageType.ERROR, 'Il servizio è momentaneamente non disponibile.' +
            ' Riprovare fra alcuni secondi.');
          return observableThrowError(null);
        }),);

    }));
  }

}
